module.exports = "/_next/static/images/c2c41eb836ccaab5be638dc2495381ea-challenge-the-system-lg@3x.jpg.webp";